"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _pick2 = _interopRequireDefault(require("lodash/pick"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _cccisdConfirm = _interopRequireDefault(require("cccisd-confirm"));
var _Headlight = _interopRequireDefault(require("./Headlight.js"));
var _AssignmentModalContents = _interopRequireDefault(require("../ModalContents/AssignmentModalContents.js"));
var _SurveyModalContents = _interopRequireDefault(require("../ModalContents/SurveyModalContents.js"));
var _CourseWrapper = _interopRequireDefault(require("../ModalContents/CourseWrapper"));
var _SessionDataEntry = _interopRequireDefault(require("../ModalContents/SessionDataEntry"));
var _OutcomesDataEntry = _interopRequireDefault(require("../ModalContents/OutcomesDataEntry"));
var _WithModules = _interopRequireDefault(require("../ModalContents/WithModules"));
var _styleAssignmentcard = _interopRequireDefault(require("./style-assignmentcard.css"));
var _arrowDown = _interopRequireDefault(require("cccisd-icons/arrow-down5"));
var _book = _interopRequireDefault(require("cccisd-icons/book3"));
var _plus = _interopRequireDefault(require("cccisd-icons/plus2"));
var _eye = _interopRequireDefault(require("cccisd-icons/eye"));
var _pencil = _interopRequireDefault(require("cccisd-icons/pencil5"));
var _boxAdd = _interopRequireDefault(require("cccisd-icons/box-add"));
var _bin = _interopRequireDefault(require("cccisd-icons/bin"));
var _boxRemove = _interopRequireDefault(require("cccisd-icons/box-remove"));
var _info = _interopRequireDefault(require("cccisd-icons/info2"));
var _broom = _interopRequireDefault(require("cccisd-icons/broom"));
var _admin = require("../../reducers/admin.js");
var _reactRedux = require("react-redux");
var _SurveyCard = _interopRequireDefault(require("./SurveyCard.js"));
var _reactBeautifulDnd = require("react-beautiful-dnd");
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _HiddenBlock = _interopRequireDefault(require("../HiddenBlock"));
var _HighlightWord = _interopRequireDefault(require("../HighlightWord"));
var _JsonForm = _interopRequireDefault(require("./JsonForm"));
var _generatePreviewHash = _interopRequireDefault(require("../../helpers/generatePreviewHash.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Boilerplate = window.cccisd && window.cccisd.boilerplate;
var Fortress = window.cccisd && window.cccisd.fortress;
var AssignmentCard = /*#__PURE__*/function (_React$Component) {
  function AssignmentCard() {
    var _this;
    _classCallCheck(this, AssignmentCard);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, AssignmentCard, [].concat(args));
    _defineProperty(_this, "state", {
      loading: false,
      isWithModulesUnsavedChanges: false
    });
    _defineProperty(_this, "archiveAssignment", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var _this$props, assignmentData, assignmentTerm, isSuccess;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this$props = _this.props, assignmentData = _this$props.assignmentData, assignmentTerm = _this$props.assignmentTerm;
            _this.setState({
              loading: true
            });
            _context.n = 1;
            return _this.props.archiveQuest(assignmentData.assignmentId);
          case 1:
            isSuccess = _context.v;
            if (isSuccess) {
              (0, _cccisdNotification["default"])("".concat(assignmentTerm, " successfully archived"));
            } else {
              (0, _cccisdNotification["default"])({
                type: 'danger',
                message: "".concat(assignmentTerm, " failed to archive")
              });
              _this.setState({
                loading: false
              });
            }
          case 2:
            return _context.a(2);
        }
      }, _callee);
    })));
    _defineProperty(_this, "unarchiveAssignment", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var _this$props2, assignmentData, assignmentTerm, isSuccess;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            _this$props2 = _this.props, assignmentData = _this$props2.assignmentData, assignmentTerm = _this$props2.assignmentTerm;
            _this.setState({
              loading: true
            });
            _context2.n = 1;
            return _this.props.unarchiveQuest(assignmentData.assignmentId);
          case 1:
            isSuccess = _context2.v;
            if (isSuccess) {
              (0, _cccisdNotification["default"])("".concat(assignmentTerm, " successfully unarchived"));
            } else {
              (0, _cccisdNotification["default"])({
                type: 'danger',
                message: "".concat(assignmentTerm, " failed to unarchive")
              });
              _this.setState({
                loading: false
              });
            }
          case 2:
            return _context2.a(2);
        }
      }, _callee2);
    })));
    _defineProperty(_this, "deleteAssignment", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
      var _this$props3, assignmentData, assignmentTerm, isSuccess;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            _this$props3 = _this.props, assignmentData = _this$props3.assignmentData, assignmentTerm = _this$props3.assignmentTerm;
            _this.setState({
              loading: true
            });
            _context3.n = 1;
            return _this.props.deleteQuest(assignmentData.assignmentId);
          case 1:
            isSuccess = _context3.v;
            if (isSuccess) {
              (0, _cccisdNotification["default"])(assignmentTerm + ' successfully deleted');
            } else {
              (0, _cccisdNotification["default"])({
                type: 'danger',
                message: assignmentTerm + ' failed to delete'
              });
              _this.setState({
                loading: false
              });
            }
          case 2:
            return _context3.a(2);
        }
      }, _callee3);
    })));
    _defineProperty(_this, "onUpdateAssignment", /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(values) {
        var _this$props4, assignmentData, assignmentTerm, _t;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _this$props4 = _this.props, assignmentData = _this$props4.assignmentData, assignmentTerm = _this$props4.assignmentTerm;
              _context4.p = 1;
              _context4.n = 2;
              return _this.props.updateQuest(assignmentData.assignmentId, _objectSpread(_objectSpread({}, assignmentData.settings), values));
            case 2:
              (0, _cccisdNotification["default"])("".concat(assignmentTerm, " successfully updated"));
              _context4.n = 4;
              break;
            case 3:
              _context4.p = 3;
              _t = _context4.v;
              (0, _cccisdNotification["default"])({
                type: 'danger',
                message: "".concat(assignmentTerm, " failed to update")
              });
              throw _t;
            case 4:
              _this.editQuestModal.close();
            case 5:
              return _context4.a(2);
          }
        }, _callee4, null, [[1, 3]]);
      }));
      return function (_x) {
        return _ref4.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "_renderSurveylistListDropdown", function () {
      var assignmentData = _this.props.assignmentData;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("select", {
        "data-switch-survey-list-list": assignmentData.assignmentId,
        className: "form-select form-select-sm",
        style: {
          height: '1.9em',
          lineHeight: '1.9em'
        },
        value: assignmentData.currentSurveylistList.surveylistHandle,
        onChange: function onChange(e) {
          return _this.props.setCurrentSurveyListHandle({
            assignmentId: assignmentData.assignmentId,
            handle: e.target.value
          });
        }
      }, assignmentData.surveylistList.map(function (surveylist) {
        return /*#__PURE__*/_react["default"].createElement("option", {
          key: surveylist.surveylistHandle,
          value: surveylist.surveylistHandle
        }, surveylist.surveylistHandle);
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: _styleAssignmentcard["default"].headlightPipe
      }));
    });
    // render the headlight of the card
    _defineProperty(_this, "_renderHeadlight", function () {
      var _assignmentData$setti, _assignmentData$setti2, _assignmentData$setti3, _assignmentData$setti4, _assignmentData$setti5, _assignmentData$setti6, _assignmentData$setti7, _assignmentData$setti8, _assignmentData$setti9, _assignmentData$setti0, _assignmentData$setti1, _assignmentData$setti10;
      var _this$props5 = _this.props,
        assignmentTerm = _this$props5.assignmentTerm,
        assignmentData = _this$props5.assignmentData;
      var isWithModulesUnsavedChanges = _this.state.isWithModulesUnsavedChanges;
      var useCourseWrapper = assignmentData.settings.navigation && assignmentData.settings.navigation.match(/^courseWrapper/);
      var useSessionDataEntry = assignmentData.settings.navigation && assignmentData.settings.navigation.match(/^sessionDataEntry/);
      var useOutcomesDataEntry = assignmentData.settings.navigation && assignmentData.settings.navigation.match(/^outcomesDataEntry/);
      var useWithModules = assignmentData.settings.navigation && assignmentData.settings.navigation.match(/^module/) || useCourseWrapper && [assignmentData === null || assignmentData === void 0 ? void 0 : (_assignmentData$setti = assignmentData.settings) === null || _assignmentData$setti === void 0 ? void 0 : (_assignmentData$setti2 = _assignmentData$setti.navigationSettings) === null || _assignmentData$setti2 === void 0 ? void 0 : (_assignmentData$setti3 = _assignmentData$setti2.registration) === null || _assignmentData$setti3 === void 0 ? void 0 : _assignmentData$setti3.navigation, assignmentData === null || assignmentData === void 0 ? void 0 : (_assignmentData$setti4 = assignmentData.settings) === null || _assignmentData$setti4 === void 0 ? void 0 : (_assignmentData$setti5 = _assignmentData$setti4.navigationSettings) === null || _assignmentData$setti5 === void 0 ? void 0 : (_assignmentData$setti6 = _assignmentData$setti5.course) === null || _assignmentData$setti6 === void 0 ? void 0 : _assignmentData$setti6.navigation, assignmentData === null || assignmentData === void 0 ? void 0 : (_assignmentData$setti7 = assignmentData.settings) === null || _assignmentData$setti7 === void 0 ? void 0 : (_assignmentData$setti8 = _assignmentData$setti7.navigationSettings) === null || _assignmentData$setti8 === void 0 ? void 0 : (_assignmentData$setti9 = _assignmentData$setti8.courseEval) === null || _assignmentData$setti9 === void 0 ? void 0 : _assignmentData$setti9.navigation, assignmentData === null || assignmentData === void 0 ? void 0 : (_assignmentData$setti0 = assignmentData.settings) === null || _assignmentData$setti0 === void 0 ? void 0 : (_assignmentData$setti1 = _assignmentData$setti0.navigationSettings) === null || _assignmentData$setti1 === void 0 ? void 0 : (_assignmentData$setti10 = _assignmentData$setti1.finalTest) === null || _assignmentData$setti10 === void 0 ? void 0 : _assignmentData$setti10.navigation].find(function (handle) {
        return handle && handle.match(/^module/);
      });
      return assignmentData.archived ? /*#__PURE__*/_react["default"].createElement(_Headlight["default"], {
        style: {
          backgroundColor: '#f1f0f4'
        }
      }, /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: "Unarchive"
      }, /*#__PURE__*/_react["default"].createElement("a", {
        className: "btn btn-xs btn-info",
        "data-unarchive-quest-button": assignmentData.assignmentId,
        onClick: _this.unarchiveAssignment
      }, /*#__PURE__*/_react["default"].createElement(_boxRemove["default"], null))), _this._renderDeleteActionButton()) : /*#__PURE__*/_react["default"].createElement(_Headlight["default"], {
        style: {
          backgroundColor: '#f1f0f4'
        }
      }, assignmentData.surveylistList.length > 1 && _this._renderSurveylistListDropdown(), /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        trigger: /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
          title: "Edit Quest"
        }, /*#__PURE__*/_react["default"].createElement("a", {
          "data-edit-quest-button": assignmentData.assignmentId,
          className: "btn btn-xs btn-success"
        }, /*#__PURE__*/_react["default"].createElement(_pencil["default"], null))),
        size: "large",
        title: "Edit ".concat(assignmentTerm),
        ref: function ref(elem) {
          _this.editQuestModal = elem;
        }
      }, /*#__PURE__*/_react["default"].createElement(_AssignmentModalContents["default"], {
        assignmentTerm: assignmentTerm,
        assignmentData: assignmentData,
        onSubmit: _this.onUpdateAssignment,
        initialValues: _objectSpread(_objectSpread({}, (0, _pick2["default"])(assignmentData.settings, ['languages', 'buildLanguages', 'navigation', 'navigationSettings', 'frameStyleId', 'frameStyleSettings', 'showHeader', 'showFooter'])), {}, {
          title: assignmentData.label,
          subtitle: assignmentData.description,
          productId: assignmentData.product.productId || ''
        })
      })), useWithModules && /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        contentStyle: {
          maxWidth: '1140px'
        },
        beforeClose: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
          return _regenerator().w(function (_context5) {
            while (1) switch (_context5.n) {
              case 0:
                if (isWithModulesUnsavedChanges) {
                  _context5.n = 1;
                  break;
                }
                return _context5.a(2);
              case 1:
                _context5.n = 2;
                return (0, _cccisdConfirm["default"])({
                  message: 'Are you sure?',
                  description: 'You have unsaved changes!',
                  confirmLabel: 'Yes, discard changes',
                  abortLabel: 'No, continue editing'
                }).then(function () {
                  _this.setState({
                    isWithModulesUnsavedChanges: false
                  });
                });
              case 2:
                return _context5.a(2);
            }
          }, _callee5);
        })),
        size: "calc(100vw - 40px)",
        title: "Configure Dashboard for \"".concat(assignmentData.label, "\""),
        render: function render(_ref6) {
          var closeModal = _ref6.closeModal;
          return /*#__PURE__*/_react["default"].createElement(_WithModules["default"], {
            assignmentData: assignmentData,
            closeModal: closeModal,
            isWithModulesUnsavedChanges: isWithModulesUnsavedChanges,
            setIsWithModulesUnsavedChanges: function setIsWithModulesUnsavedChanges(bool) {
              return _this.setState({
                isWithModulesUnsavedChanges: bool
              });
            }
          });
        },
        trigger: /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
          title: "Configure Dashboard"
        }, /*#__PURE__*/_react["default"].createElement("a", {
          className: "btn btn-xs btn-info"
        }, /*#__PURE__*/_react["default"].createElement(_book["default"], null)))
      }), useCourseWrapper && /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        trigger: /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
          title: "Configure Course Wrapper"
        }, /*#__PURE__*/_react["default"].createElement("a", {
          className: "btn btn-xs btn-success"
        }, /*#__PURE__*/_react["default"].createElement(_book["default"], null))),
        title: "Configure Course Wrapper for \"".concat(assignmentData.label, "\""),
        size: "large",
        render: function render(_ref7) {
          var closeModal = _ref7.closeModal;
          return /*#__PURE__*/_react["default"].createElement(_CourseWrapper["default"], {
            assignmentData: assignmentData,
            closeModal: closeModal
          });
        }
      }), useSessionDataEntry && /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        trigger: /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
          title: "Configure Session Data Entry"
        }, /*#__PURE__*/_react["default"].createElement("a", {
          className: "btn btn-xs btn-success"
        }, /*#__PURE__*/_react["default"].createElement(_book["default"], null))),
        title: "Configure Session Data Entry",
        size: "large",
        render: function render(_ref8) {
          var closeModal = _ref8.closeModal;
          return /*#__PURE__*/_react["default"].createElement(_SessionDataEntry["default"], {
            assignmentData: assignmentData,
            assignmentTerm: assignmentTerm,
            closeModal: closeModal
          });
        }
      }), useOutcomesDataEntry && /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        trigger: /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
          title: "Configure Outcomes Data Entry"
        }, /*#__PURE__*/_react["default"].createElement("a", {
          className: "btn btn-xs btn-success"
        }, /*#__PURE__*/_react["default"].createElement(_book["default"], null))),
        title: "Configure Outcomes Data Entry",
        size: "large",
        render: function render(_ref9) {
          var closeModal = _ref9.closeModal;
          return /*#__PURE__*/_react["default"].createElement(_OutcomesDataEntry["default"], {
            assignmentData: assignmentData,
            assignmentTerm: assignmentTerm,
            closeModal: closeModal
          });
        }
      }), !!Fortress.user.acting.is_super_user && /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        trigger: /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
          title: "Settings JSON Editor"
        }, /*#__PURE__*/_react["default"].createElement("a", {
          "data-edit-quest-json-button": assignmentData.assignmentId,
          className: "btn btn-xs btn-warning"
        }, /*#__PURE__*/_react["default"].createElement(_broom["default"], null))),
        title: "Settings JSON Editor for Quest \"".concat(assignmentData.label, "\"")
      }, /*#__PURE__*/_react["default"].createElement(_JsonForm["default"], {
        onSubmit: _this.onUpdateAssignmentJson,
        assignmentData: assignmentData
      })), /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: "Archive"
      }, /*#__PURE__*/_react["default"].createElement("a", {
        className: "btn btn-xs btn-primary",
        "data-archive-quest-button": assignmentData.assignmentId,
        onClick: function onClick() {
          (0, _cccisdConfirm["default"])({
            message: 'Confirm archive?',
            description: 'Are you sure you want to archive ' + assignmentTerm + " '" + assignmentData.label + "'?",
            confirmLabel: 'Yes',
            abortLabel: 'Cancel'
          }).then(_this.archiveAssignment);
        }
      }, /*#__PURE__*/_react["default"].createElement(_boxAdd["default"], null))), _this._renderDeleteActionButton());
    });
    _defineProperty(_this, "_renderDeleteActionButton", function () {
      var _this$props6 = _this.props,
        assignmentData = _this$props6.assignmentData,
        assignmentTerm = _this$props6.assignmentTerm;
      var deleteDescription = function deleteDescription() {
        var defaultMessage = 'Are you sure you want to delete ' + assignmentTerm + " '" + assignmentData.label + "'?";
        var sternWarning = /*#__PURE__*/_react["default"].createElement("div", null, "Deleting this data collection wave will ", /*#__PURE__*/_react["default"].createElement("strong", null, "delete all data"), " associated with this project. Are you sure you want to delete ", assignmentTerm, " ", "'", assignmentData.label, "'", "?");
        if (assignmentTerm === 'Quest' && assignmentData.deploymentList.length > 0) {
          var metrics = [];
          assignmentData.deploymentList.map(function (deployment) {
            return deployment.lastResponseEnteredAt ? metrics.push(deployment) : null;
          });
          return metrics.length > 0 ? sternWarning : defaultMessage;
        }
        return defaultMessage;
      };
      return /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: "Delete"
      }, /*#__PURE__*/_react["default"].createElement("a", {
        className: "btn btn-xs btn-danger",
        "data-delete-quest-button": assignmentData.assignmentId,
        onClick: function onClick() {
          (0, _cccisdConfirm["default"])({
            message: 'Confirm delete?',
            description: deleteDescription(),
            confirmLabel: 'Yes',
            abortLabel: 'Cancel'
          }).then(_this.deleteAssignment);
        }
      }, /*#__PURE__*/_react["default"].createElement(_bin["default"], null)));
    });
    // render the right side of the header bar based on expanded/collapsed card
    _defineProperty(_this, "_renderHeaderRightSide", function () {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _styleAssignmentcard["default"].rightSide
      }, _this.props.isExpanded && !_this.props.assignmentData.archived && /*#__PURE__*/_react["default"].createElement("div", {
        className: _styleAssignmentcard["default"].expandedHeader
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames2["default"])('text-primary', _styleAssignmentcard["default"].infoBubble)
      }, /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: "A Survey is a collection of questions, media, and/or interactives for data collection. Surveys in a Quest are taken in the order shown."
      }, /*#__PURE__*/_react["default"].createElement(_info["default"], null))), _this._renderCreateSurveyModal()), _this._renderPreviewAllBtn());
    });
    _defineProperty(_this, "onCreateSurvey", /*#__PURE__*/function () {
      var _ref0 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(values) {
        var assignmentData, surveyListId, isSuccess, _t2;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              assignmentData = _this.props.assignmentData;
              surveyListId = assignmentData.currentSurveylistList.surveylistId;
              _context6.p = 1;
              _context6.n = 2;
              return _this.props.createSurvey(surveyListId, values);
            case 2:
              isSuccess = _context6.v;
              if (isSuccess) {
                (0, _cccisdNotification["default"])("Survey \"".concat(values.title, "\"\" successfully created"));
              } else {
                (0, _cccisdNotification["default"])({
                  type: 'danger',
                  message: 'Survey failed to create'
                });
              }
              _this.createSurveyModal.close();
              _context6.n = 4;
              break;
            case 3:
              _context6.p = 3;
              _t2 = _context6.v;
              return _context6.a(2, Promise.reject(_t2));
            case 4:
              return _context6.a(2);
          }
        }, _callee6, null, [[1, 3]]);
      }));
      return function (_x2) {
        return _ref0.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "_renderCreateSurveyModal", function () {
      var _this$props7 = _this.props,
        assignmentTerm = _this$props7.assignmentTerm,
        assignmentData = _this$props7.assignmentData,
        project = _this$props7.project;

      // display text to identify assignment and project names
      var assignmentProjectStr = 'For ' + assignmentTerm + " '" + assignmentData.label + "'";
      if (project.label !== '') {
        assignmentProjectStr += " in Quest Project '" + project.label + "'";
      }
      return /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        trigger: /*#__PURE__*/_react["default"].createElement("a", {
          className: "btn btn-primary btn-sm",
          type: "button",
          "data-create-survey-button": assignmentData.assignmentId
        }, /*#__PURE__*/_react["default"].createElement(_plus["default"], {
          spaceRight: true
        }), "Create Survey"),
        title: "Create Survey",
        ref: function ref(elem) {
          _this.createSurveyModal = elem;
        }
      }, /*#__PURE__*/_react["default"].createElement(_SurveyModalContents["default"], {
        assignmentProjectStr: assignmentProjectStr,
        onSubmit: _this.onCreateSurvey,
        initialValues: {
          isRequired: true
        }
      }));
    });
    _defineProperty(_this, "_renderPreviewAllBtn", function () {
      var _this$props8 = _this.props,
        assignmentData = _this$props8.assignmentData,
        assignmentTerm = _this$props8.assignmentTerm;

      // show disabled button if archived
      if (assignmentData.archived) {
        return /*#__PURE__*/_react["default"].createElement("button", {
          className: "btn btn-secondary btn-sm",
          type: "button",
          disabled: true
        }, "This ", assignmentTerm, " is archived");
      }

      // get total number of surveys
      var numSurveys = assignmentData.currentSurveylistList.surveyList.filter(function (item) {
        return !item.archived;
      }).length;

      // show button if surveys exist
      if (numSurveys > 0) {
        var hash = (0, _generatePreviewHash["default"])(assignmentData.assignmentId);
        return /*#__PURE__*/_react["default"].createElement("a", {
          type: "button",
          className: "btn btn-primary btn-sm",
          target: "_blank",
          rel: "noopener noreferrer",
          href: Boilerplate.url("quest/preview/quest/".concat(assignmentData.assignmentId, "/").concat(hash))
        }, /*#__PURE__*/_react["default"].createElement(_eye["default"], {
          spaceRight: true
        }), "Preview ", assignmentTerm);
      }

      // show disabled button only if collapsed
      if (!_this.props.isExpanded) {
        return /*#__PURE__*/_react["default"].createElement("button", {
          className: "btn btn-secondary btn-sm",
          type: "button",
          disabled: true
        }, "There are no surveys");
      }
    });
    _defineProperty(_this, "onDragEnd", function (result) {
      if (!result.destination || result.destination.index === result.source.index) {
        return;
      }
      _this.props.moveSurveyAndSave({
        assignmentId: _this.props.assignmentData.assignmentId,
        sourceIndex: result.source.index,
        destinationIndex: result.destination.index
      });
    });
    // render the body of the card
    _defineProperty(_this, "_renderBody", function () {
      var _this$props9 = _this.props,
        assignmentTerm = _this$props9.assignmentTerm,
        assignmentData = _this$props9.assignmentData,
        designFilter = _this$props9.designFilter;
      var allSurveys = assignmentData.currentSurveylistList.surveyList.sort(function (a, b) {
        return a.position - b.position;
      });
      var surveys = allSurveys.filter(function (item) {
        return !item.archived;
      });
      var archivedSurveys = allSurveys.filter(function (item) {
        return item.archived;
      });
      var emptyText = '';
      if (surveys.length === 0) {
        if (assignmentData.archived) {
          // set text based on assignment archive state
          emptyText = 'This ' + assignmentTerm + ' is empty';
        } else {
          // set text based on having only-archived surveys
          emptyText = archivedSurveys.length > 0 ? 'Create a new survey...' : 'Create a survey to begin...';
        }
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _styleAssignmentcard["default"].content
      }, emptyText && /*#__PURE__*/_react["default"].createElement("h3", {
        className: _styleAssignmentcard["default"].empty
      }, emptyText), /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.DragDropContext, {
        onDragEnd: _this.onDragEnd
      }, /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.Droppable, {
        droppableId: "droppable"
      }, function (provided, snapshot) {
        return /*#__PURE__*/_react["default"].createElement("div", _extends({}, provided.droppableProps, {
          ref: provided.innerRef
        }), surveys.map(function (survey, index) {
          return /*#__PURE__*/_react["default"].createElement(_SurveyCard["default"], {
            key: survey.surveyHandle,
            index: index,
            surveyData: survey,
            project: _this.props.project,
            assignmentTerm: assignmentTerm,
            assignment: assignmentData,
            isAssignmentArchived: assignmentData.archived,
            isDragDisabled: surveys.length < 2,
            designFilter: designFilter
          });
        }), provided.placeholder);
      })), archivedSurveys.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginTop: '2em'
        }
      }, /*#__PURE__*/_react["default"].createElement(_HiddenBlock["default"], {
        label: "Archived Surveys (".concat(archivedSurveys.length, ")"),
        show: _this.props.expandedArchivedSurveys.includes(assignmentData.assignmentId),
        toggle: function toggle() {
          return _this.props.toggleArchivedSurveys(assignmentData.assignmentId);
        }
      }, archivedSurveys.map(function (survey) {
        return /*#__PURE__*/_react["default"].createElement(_SurveyCard["default"], {
          key: survey.surveyHandle,
          surveyData: survey,
          project: _this.props.project,
          assignmentTerm: assignmentTerm,
          assignment: assignmentData,
          isAssignmentArchived: assignmentData.archived,
          designFilter: designFilter
        });
      }))));
    });
    _defineProperty(_this, "toggleCollapse", function () {
      _this.props.toggleCollapsedDesignAssignment(_this.props.assignmentData.assignmentId);
    });
    return _this;
  }
  _inherits(AssignmentCard, _React$Component);
  return _createClass(AssignmentCard, [{
    key: "render",
    value: function render() {
      var _this$props0 = this.props,
        assignmentData = _this$props0.assignmentData,
        isExpanded = _this$props0.isExpanded,
        designFilter = _this$props0.designFilter;
      return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
        loading: this.state.loading
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames2["default"])(_styleAssignmentcard["default"].cardWrapper, _defineProperty({}, _styleAssignmentcard["default"].expanded, isExpanded)),
        "data-assignment-card": assignmentData.assignmentId
      }, isExpanded && this._renderHeadlight(), /*#__PURE__*/_react["default"].createElement("div", {
        className: _styleAssignmentcard["default"].header
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _styleAssignmentcard["default"].leftSide,
        onClick: this.toggleCollapse
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: [_styleAssignmentcard["default"].collapseArrow, isExpanded ? _styleAssignmentcard["default"].expanded : _styleAssignmentcard["default"].collapsed].join(' ')
      }, /*#__PURE__*/_react["default"].createElement(_arrowDown["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
        className: _styleAssignmentcard["default"].titleArea
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _styleAssignmentcard["default"].title
      }, /*#__PURE__*/_react["default"].createElement(_HighlightWord["default"], {
        string: assignmentData.label,
        word: designFilter
      })), isExpanded && assignmentData.description && /*#__PURE__*/_react["default"].createElement("div", {
        className: _styleAssignmentcard["default"].description
      }, /*#__PURE__*/_react["default"].createElement(_HighlightWord["default"], {
        string: assignmentData.description,
        word: designFilter
      })))), this._renderHeaderRightSide()), isExpanded && this._renderBody()));
    }
  }]);
}(_react["default"].Component);
_defineProperty(AssignmentCard, "propTypes", {
  isExpanded: _propTypes["default"].bool,
  project: _propTypes["default"].object.isRequired,
  assignmentData: _propTypes["default"].object.isRequired,
  assignmentTerm: _propTypes["default"].string,
  isArchived: _propTypes["default"].bool,
  numActiveSurveys: _propTypes["default"].number,
  startExpanded: _propTypes["default"].bool,
  alwaysShowSubtitle: _propTypes["default"].bool,
  updateQuest: _propTypes["default"].func,
  archiveQuest: _propTypes["default"].func,
  unarchiveQuest: _propTypes["default"].func,
  deleteQuest: _propTypes["default"].func,
  createSurvey: _propTypes["default"].func,
  toggleCollapsedDesignAssignment: _propTypes["default"].func,
  toggleArchivedSurveys: _propTypes["default"].func,
  moveSurveyAndSave: _propTypes["default"].func,
  expandedArchivedSurveys: _propTypes["default"].array,
  designFilter: _propTypes["default"].string
});
_defineProperty(AssignmentCard, "defaultProps", {
  isArchived: false,
  startExpanded: false,
  alwaysShowSubtitle: false,
  assignmentTerm: 'Assignment'
});
var _default = exports["default"] = (0, _reactRedux.connect)(function (state) {
  return {
    expandedArchivedSurveys: state.assignment.admin.showArchivedSurveys,
    designFilter: state.assignment.admin.designFilter
  };
}, {
  updateQuest: _admin.updateQuest,
  archiveQuest: _admin.archiveQuest,
  unarchiveQuest: _admin.unarchiveQuest,
  deleteQuest: _admin.deleteQuest,
  createSurvey: _admin.createSurvey,
  toggleCollapsedDesignAssignment: _admin.toggleCollapsedDesignAssignment,
  toggleArchivedSurveys: _admin.toggleArchivedSurveys,
  moveSurveyAndSave: _admin.moveSurveyAndSave,
  setCurrentSurveyListHandle: _admin.setCurrentSurveyListHandle
})(AssignmentCard);